
<button class="reload" matTooltip="Actualizar" type="button" (click)="reload()" mat-icon-button>
    <mat-icon>cached</mat-icon>
</button>
